import { cn } from "@omni/utils/styles";

type PreviewElementProps = { label: string; value: string; animate?: boolean };

const PreviewElement = ({ label, value, animate }: PreviewElementProps) => {
    return (
        <p
            className={cn("tw:p-2 tw:inline-block tw:md:block", {
                "tw:animate-slide-in-right tw:md:animate-slide-in-left": animate
            })}
        >
            <span className={cn("tw:font-semibold tw:pr-1")}>
                {label}
                {": "}
            </span>
            {value}
        </p>
    );
};

export { PreviewElement };
